import "@/App.css";
import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { Landing } from "@/components/Landing";
import { LoginModal } from "@/components/LoginModal";
import Dashboard from "@/components/Dashboard";
import { FloatingWA } from "@/components/FloatingWA";
import { getSettings, getSession, clearSession } from "@/lib/api";
import { photoSrc } from "@/lib/constants";

function App() {
  const [settings, setSettings] = useState(null);
  const [session, setSessionState] = useState(getSession());
  const [view, setView] = useState("landing");
  const [showLogin, setShowLogin] = useState(false);

  const loadSettings = async () => {
    try { setSettings(await getSettings()); } catch { /* ignore */ }
  };
  useEffect(() => { loadSettings(); }, []);

  useEffect(() => {
    if (!settings) return;
    if (settings.company_name) {
      document.title = settings.company_name + (settings.tagline ? ` — ${settings.tagline}` : "");
    }
    if (settings.logo_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = photoSrc(settings.logo_url);
    }
  }, [settings]);

  const onLoginSuccess = (data) => {
    setShowLogin(false);
    setSessionState(getSession());
    setView("dashboard");
  };

  const onLogout = () => {
    clearSession();
    setSessionState(null);
    setView("landing");
  };

  return (
    <div className="App">
      {view === "dashboard" && session ? (
        <Dashboard
          session={session}
          settings={settings}
          onHome={() => setView("landing")}
          onLogout={onLogout}
          onSettingsChanged={(s) => setSettings(s)}
        />
      ) : (
        <Landing settings={settings} onLoginClick={() => (session ? setView("dashboard") : setShowLogin(true))} />
      )}
      <LoginModal open={showLogin} onClose={() => setShowLogin(false)} onSuccess={onLoginSuccess} />
      <FloatingWA whatsapp={settings?.whatsapp} company={settings?.company_name} />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
